/**
 * @file Identity Create action.
 */
import { photoUploadSuccess } from '../../../../actions/photo-upload';
import getLogger from '../../../../util/logger';
import { getErrorString } from '../../../../util/normalize-errors';

const log = getLogger('IdentityCreateAction');

export const IDENTITY_CREATE_REQUEST = 'identity/CREATE_REQUEST';
export const IDENTITY_CREATE_SUCCESS = 'identity/CREATE_SUCCESS';
export const IDENTITY_CREATE_FAILURE = 'identity/CREATE_FAILURE';
export const IDENTITY_CREATE_RESET = 'identity/CREATE_RESET';

const identityCreateRequest = () => {
  return { type: IDENTITY_CREATE_REQUEST };
};

const identityCreateSuccess = identity => {
  return { type: IDENTITY_CREATE_SUCCESS, identity };
};

const identityCreateFailure = error => {
  return { type: IDENTITY_CREATE_FAILURE, error };
};

export const identityCreateReset = () => {
  return { type: IDENTITY_CREATE_RESET };
};

export const identityCreate = async ({
  accountId,
  identityFirstName,
  identityLastName,
  gender,
  file,
  dispatch,
  identityCreateMutation,
}) => {
  log.info('identityCreate() :: Creating identity...', identityFirstName);

  dispatch(identityCreateRequest());

  try {
    const identityCreateRes = await identityCreateMutation({
      accountId,
      firstName: identityFirstName,
      lastName: identityLastName,
      gender,
      photoId: file.id,
    });
    const { identity } = identityCreateRes.data.identityCreate;

    log.info('identityCreate() :: Identity created');

    dispatch(photoUploadSuccess({ identityId: identity.id, ...file }, false));
    dispatch(identityCreateSuccess(identity));

    return identity;
  } catch (error) {
    log.error('identityCreate() :: Error:', error);

    dispatch(identityCreateFailure(getErrorString(error)));
    return undefined;
  }
};
